import { createAction } from 'redux-actions';
import { modalActions } from '../constants';

export const openModal = createAction(modalActions.SHOW_MODAL);
export const hideModal = createAction(modalActions.HIDE_MODAL);
